import React from "react";
import Widget from "../Widget";
import { observer, inject } from "mobx-react";
import { action } from "mobx";

import "./MonitorEvents.scss";
import EventsStore from "./components/EventsSidebar/EventsStore";
import Loader from "../../shared/Loader/Loader";
import SubNav from "./SubNav";
import Icon from "../../shared/Icon";
import { formatDate } from "../../shared/dateTimeUtils";
import className from "../../shared/className";
import { formatTime } from "../../shared/dateTimeUtils";

class MonitorEvents extends Widget {
  constructor(props) {
    super(props);
    this.store = new EventsStore({
      asmpid: this.asmpid,
      isPage: true,
      appStore: this.props.store,
    });
    this.props.store.monitorStore = undefined;
    this.store.fetchPmEvents({ query: { count: undefined, discretes: true } });
  }

  render() {
    return (
      <div className="monitor-events widget">
        <SubNav
          asmpid={this.asmpid}
          location={this.props.location}
          disable={{ tools: true }}
        />
        <EventsList
          store={this.store}
          history={this.props.history}
          expandable={true}
        />
      </div>
    );
  }

  refresh = () => {
    this.store.fetchPmEvents({ reset: true });
  };
}

export default inject("store")(observer(MonitorEvents));

export const EventsList = observer(function EventsList({
  store,
  history,
  expandable,
  selectEvent,
  parent,
}) {
  const gotoEvent = action(function gotoEvent(pmEvent) {
    selectEvent?.(pmEvent);
    history.push(
      `/patient/${store.asmpid}/monitor/${
        parent?.props.match.params.historyType || "event-history"
      }/${encodeURIComponent(pmEvent.eventTime)}`,
    );
  });

  if (store.loadingEvents) return <Loader />;
  return (
    <div className="segments">
      {store.eventSegments.map((segment) => (
        <div
          {...className({
            segment: true,
            expanded: expandable && store.expandedSegments[segment.title],
          })}
          key={segment.title}
        >
          <div className="header">
            {segment.title}
            <div
              {...className({
                "expand-toggle": true,
                expanded: expandable && store.expandedSegments[segment.title],
              })}
              onClick={() => expandable && toggleExpand({ segment, store })}
            >
              {expandable && (
                <>
                  {segment.expanded ? "Collapse" : "Expand"}
                  <Icon symbol="dropdown" />
                </>
              )}
            </div>
          </div>
          <div className="events">
            <EventsInner {...{ segment, store, gotoEvent, expandable }} />
          </div>{" "}
          {/* /.events */}
        </div>
      ))}
    </div>
  );
});

const toggleExpand = action(function toggleExpand({ segment, store }) {
  store.expandedSegments[segment.title] =
    !store.expandedSegments[segment.title];
});

const EventsInner = observer(({ segment, store, gotoEvent, expandable }) => (
  <div className="events-inner">
    {segment.events.map((event, i, events) => (
      <SegmentEvents
        {...{ event, i, events, store, expandable, gotoEvent, segment }}
        key={event.eventTime + event.message}
      />
    ))}
  </div>
));

const SegmentEvents = observer(
  ({ event, i, events, store, expandable, gotoEvent, segment }) => (
    <React.Fragment>
      {store.isPage &&
      segment === store.eventSegments.lastItem &&
      (i === 0 || event.day !== events[i - 1].day) ? (
        <div className="date-header">
          {event.day || formatDate(event.eventTime)}
        </div>
      ) : null}
      <div
        {...className({
          event: 1,
          [event.level.toLowerCase()]: 1,
          selected:
            store.selectedEvent?.eventTime === event.eventTime &&
            store.selectedEvent?.message === event.message,
        })}
        onClick={() => gotoEvent(event)}
        data-event-time={event.eventTime}
      >
        <div className="summary">
          <div className="message">{event.message}</div>
          <div className="time">{formatTime(event.eventTime)}</div>
        </div>
        {expandable && (
          <div className="discrete-data">
            {event.discreteData?.map((discrete) => (
              <div className="discrete" key={discrete.key}>
                <div className="title">{discrete.group?.title}</div>
                <div
                  className="value"
                  style={{ color: `#${discrete.group?.textColor.slice(-6)}` }}
                >
                  {discrete.data || "--"}
                  <span className="unit"></span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  ),
);
